module.exports = {
  currency: 'RM',
  googleApiKey: "AIzaSyCqjCnCIh7d84oKyUhEH888dz6FnR73R-U",
}
